import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminGet, adminPost } from "@/lib/adminApi";
import { Avatar } from "@/components/admin/ClientFiche";

export default function Rgpd() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");

  const load = () => adminGet("/users").then((d) => setUsers(d.users)).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const filtered = users.filter(
    (u) =>
      u.email.toLowerCase().includes(search.toLowerCase()) ||
      (u.name || "").toLowerCase().includes(search.toLowerCase()) ||
      (u.last_name || "").toLowerCase().includes(search.toLowerCase()),
  );

  const exportData = async (u) => {
    try {
      const data = await adminGet(`/users/${u.id}/export`);
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `rgpd-export-${u.email}.json`;
      a.click();
      URL.revokeObjectURL(a.href);
      toast("Export RGPD téléchargé.");
    } catch {
      toast("Export impossible.");
    }
  };

  const anonymize = async (u) => {
    if (!window.confirm(`Anonymiser ${u.name || u.email} ?\n\nToutes ses données personnelles (nom, e-mail, naissance, adresse, téléphone, photo, messages) seront effacées de façon définitive. Son activité restera visible de façon anonyme.`)) return;
    try {
      await adminPost(`/users/${u.id}/anonymize`, {});
      toast("Compte anonymisé.");
      load();
    } catch (err) {
      toast(err.response?.data?.detail || "Anonymisation impossible.");
    }
  };

  return (
    <div data-testid="admin-rgpd-module">
      <h2 className="rav-admin-h2">RGPD</h2>
      <p className="rav-page-sub rav-admin-note">
        Droit d'accès (export de toutes les données d'une personne) et droit à l'oubli (anonymisation définitive).
      </p>
      <input
        className="rav-input rav-admin-search"
        data-testid="rgpd-search"
        placeholder="Rechercher une personne…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <div className="rav-admin-list">
        {filtered.map((u, i) => (
          <div key={u.id} className="rav-admin-row rav-admin-user-row" data-testid={`rgpd-row-${i}`}>
            <Avatar user={u} size={40} />
            <span className="rav-admin-user-texts">
              <span className="rav-admin-row-label">{[u.name, u.last_name].filter(Boolean).join(" ") || "—"}</span>
              <span className="rav-admin-row-sub">{u.email}</span>
            </span>
            <span className="rav-admin-row-actions">
              <button type="button" className="rav-text-link" data-testid={`rgpd-export-${i}`} onClick={() => exportData(u)}>
                Exporter
              </button>
              {u.role !== "superadmin" && (
                <button type="button" className="rav-text-link" data-testid={`rgpd-anonymize-${i}`} onClick={() => anonymize(u)}>
                  Anonymiser
                </button>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
